/* global module, require */
const THREE = require('three'),
	asBuffer = require('../asBuffer'),
	unit = require('../unit');

const a = unit.mm(40),
	b = unit.mm(20),
	d = unit.mm(30),
	e = unit.mm(5),
	f = unit.mm(15),
	h = unit.mm(40);

/* unused params
const c = unit.mm(5); // hole diameter
const g = unit.mm(5); // hole spacing from edge
*/

const geo = new THREE.Geometry();
const id = new THREE.Matrix4();

const connector = new THREE.BoxGeometry(f, d, h).translate(0, 0, 0);
geo.merge(connector, id);

const flat = new THREE.BoxGeometry(a, e, h).translate(-a / 2, d / 2 - e / 2, 0);
geo.merge(flat, id);

const round = new THREE.CylinderGeometry(b, b, e)
	.scale(1, 1, h / b / 2)
	.translate(-a, d / 2 - e / 2, 0);
geo.merge(round, id);

geo.merge(flat.translate(0, -d + e, 0), id);
geo.merge(round.translate(0, -d + e, 0), id);

module.exports = asBuffer(geo);
